import { Seo } from "components/Seo";
import { useTranslation } from "features/translations";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { Button, Heading5, Paragraph } from "shared/components";

import styles from "./EmptyView.module.scss";

export const EmptyView = () => {
  const { t } = useTranslation();
  const { push } = useRouter();
  const navigate = useCallback(() => {
    push("/");
  }, [push]);

  const title = t("empty_content_view.title");
  const description = t("empty_content_view.text");

  return (
    <>
      <Seo data={{ title, description }} />
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.icon}>!</div>

          <Heading5 as="h1" color="dark">
            {title}
          </Heading5>
          <Paragraph>{description}</Paragraph>

          <Button
            onClick={navigate}
            appearance="outlined"
            className={styles.button}
          >
            {t("empty_content_view.to_home_page")}
          </Button>
        </div>
      </div>
    </>
  );
};
